import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { FormInput } from '../../../components/FormInput';
import { checkDpSuccess } from '../../../utility/service/tool-service';
import { Controller } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
const InviteSubAcct = ({
    register,
    errors,
    setValidForm
}) => {
    const { t } = useTranslation();




  useEffect(()=>{

  },[])

  return (
    <div className="grid">
        <div className="col-12">
            <FormInput
                register={register}
                errors={errors}
                id="userEmail"
                type="text"
                labelText={t('companyEamil')}
                labelClass="control-label required"
                rules={setValidForm('userEmail')}
              />
        </div>
        <div className="col-12">
            <FormInput
                register={register}
                errors={errors}
                id="userName"
                type="text"
                labelText={t('user_name')}
                labelClass="control-label required"
                rules={setValidForm('userName')}
              />
        </div>
        {/* <div className="col-12">
            <FormInput
                register={register}
                errors={errors}
                id="phone"
                type="tel"
                labelText={t('tel')}
                labelClass="control-label required"
                rules={{required: { value: true, message: t('validation.required') }}}
              />
        </div> */}
       


    </div>
  )
}

export default InviteSubAcct